import { SortEvent } from 'primeng/api';
export const customTableSortTime = (event: SortEvent) => {
  const { field, data, order } = event;

  if (!data) return [];

  return data.sort((a, b) => {
    const aValue = a[field as keyof typeof a];
    const bValue = b[field as keyof typeof b];

    if (!aValue && !bValue) return 0;
    if (!aValue) return 1;
    if (!bValue) return -1;

    const getMinutesForSorting = (time: string) => {
      const [hours, minutes] = time.split(':').map(Number);
      let totalMinutes = hours * 60 + minutes;

      if (field === 'from') {
        if (hours < 6) {
          totalMinutes += 24 * 60;
        }
        return totalMinutes - 360;
      } else if (field === 'until') {
        if (hours < 6 || (hours === 6 && minutes === 0)) {
          totalMinutes += 24 * 60;
        }
        return totalMinutes - 361;
      }

      return totalMinutes;
    };

    const minutesA = getMinutesForSorting(aValue as string);
    const minutesB = getMinutesForSorting(bValue as string);

    return (order ?? 1) * (minutesA - minutesB);
  });
};
